<template>
  <div class="home">
    <navbar></navbar>
    <banner></banner>
    <moreType></moreType>
    <carClass></carClass>
    <modules></modules>
    <qrcode></qrcode>
    <!-- <activity></activity>
    <keyAccount></keyAccount>
    <news></news>
    <account></account> -->
    <foot></foot>
    <siderBar></siderBar>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Swiper from 'swiper'
  import { WOW } from 'wowjs'
  import 'swiper/dist/css/swiper.min.css'
  import 'swiper/dist/js/swiper.min.js'
  import foot from '@/components/foot.vue'
  import siderBar from '@/components/siderBar.vue'
  import navbar from '@/components/nav.vue'
  import banner from '@/components/home/banner.vue'
  import carClass from '@/components/home/class.vue'
  import modules from '@/components/home/modules.vue'  
  import qrcode from '@/components/home/qrcode.vue'  
  import moreType from '@/components/home/moreType.vue'
  import activity from '@/components/home/activity.vue'
  import keyAccount from '@/components/home/keyAccount.vue'
  import news from '@/components/home/news.vue'
  import account from '@/components/home/account.vue'
  import { mapMutations, mapGetters, mapState } from 'vuex'
  import { Lazyload } from 'vant'
  import { Image as VanImage } from 'vant'
  Vue.use(VanImage)
  Vue.use(Lazyload)
  export default {
    data () {
      return {
        bgFlag: false,
        vdFlag: false,
        muneFlag: false,
        muneIndex: -1,
        mySwiper: null,
        moveFlag: false,
        goodsList: [],

      }
    },
    components: {qrcode,modules,carClass,siderBar, navbar, banner, moreType, activity,keyAccount ,news,account,foot},
    computed: {
      ...mapState(['langFlag', 'lang', 'title']),
    },
    mounted () {
      let that = this

      // 滚动条滚动
      window.addEventListener('scroll', this.handleScroll)
      // 在项目加载完成之后初始化wow
      this.$nextTick(() => {
        let wow = new WOW({
          live: false,
        })
        wow.init()
      })

      this.$post("/api/config", {
        code:"WEB_"
      }).then((resp) => {
          if (resp.code == 1) {
              document.title = resp.data.WEB_SEO_TITLE
          }
      })
    },

    watch: {
      langFlag (val) {
        console.log('中英文的值', val)
        this.projectCate()
        this.homeSwiper()
      },
      title (val) {
        document.title = val
      },
    },
    methods: {
      // ...mapMutations(['SET_WFFLAG']),

      //  视频播放
      toPlay () {
        this.vdFlag = true
        this.$refs.videoPlayer2.play()
        // this.$refs.videoPlayer.paused === true
        //   ? this.$refs.videoPlayer.play()
        //   : this.$refs.videoPlayer.pause()
      },
      toPause () {
        // this.$refs.videoPlayer.paused === true
        //   ? this.$refs.videoPlayer.pause()
        //   : this.$refs.videoPlayer.pause()
      },

      
    },
  }
</script>
<style>
  /* @import './../assets/css/base.css'; */
  .hvde video {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .hvde {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .home_swiper .play_ico {
    position: absolute;
    left: 50%;
    width: 1rem !important;
    height: 1rem !important;
    margin: -0.5rem 0 0 -0.5rem;
    top: 50%;
    z-index: 10;
  }

  .hcom_tp .van-image__error-icon {
    min-height: 100px;
    font-size: 1rem;
  }
</style>


// WEBPACK FOOTER //
// src/pages/home.vue